import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../auth/api'

const fmtUSD = (n) => '$' + Number(n || 0).toLocaleString('en-US')

export default function Pipeline() {
    const [stages, setStages] = useState(null)
    const [error, setError] = useState('')

    useEffect(() => {
        api.get('/cases/pipeline')
            .then((res) => setStages(res.data.stages))
            .catch((err) => setError(err.response?.data?.detail || err.message))
    }, [])

    if (error) return <div className="card"><p style={{ color: 'var(--error)' }}>Error: {error}</p></div>
    if (!stages) return <div className="loading"><div className="spinner"></div><p>Loading pipeline...</p></div>

    const open = stages.filter((s) => !['won', 'lost'].includes(s.stage))
    const openValue = open.reduce((a, s) => a + s.total_value, 0)
    const won = stages.find((s) => s.stage === 'won')

    return (
        <div>
            <div className="flex-between mb-3">
                <h2>Deal Pipeline</h2>
                <div className="text-sm text-muted">
                    Open: <strong>{fmtUSD(openValue)}</strong> · Won: <strong>{fmtUSD(won?.total_value)}</strong>
                </div>
            </div>
            <div style={{ display: 'flex', gap: '12px', overflowX: 'auto', paddingBottom: '8px' }}>
                {stages.map((s) => (
                    <div key={s.stage} style={{ minWidth: '230px', flex: '1 0 230px' }}>
                        <div className="flex-between mb-2" style={{ textTransform: 'capitalize' }}>
                            <strong>{s.stage}</strong>
                            <span className="text-sm text-muted">{s.count} · {fmtUSD(s.total_value)}</span>
                        </div>
                        {s.cases.length === 0 && <p className="text-sm text-muted">—</p>}
                        {s.cases.map((c) => (
                            <Link key={c.id} to={`/cases/${c.id}`} className="card" style={{ display: 'block', marginBottom: '8px', padding: '10px' }}>
                                <div style={{ fontWeight: 600 }}>{c.case_number} — {c.client_name}</div>
                                <div className="text-sm text-muted">
                                    {c.deal_value_usd ? fmtUSD(c.deal_value_usd) : 'no value'}
                                    {c.expected_close_date ? ` · close ${String(c.expected_close_date).substring(0, 10)}` : ''}
                                </div>
                            </Link>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    )
}
